<template>
	<v-app>
		<v-toolbar app>
			<!-- <v-btn icon @click="page='Resume'"><v-icon>save</v-icon></v-btn> -->
			
			<v-toolbar-title class="headline text-uppercase">
				<span>Steven Noyce</span>
			</v-toolbar-title>
			
			<v-spacer></v-spacer>
			
			<!-- <v-toolbar-items>
				<v-btn flat @click="page='About'">About</v-btn>
			</v-toolbar-items> -->
		</v-toolbar>
		
		<v-content>
			<Resume v-if="page=='Resume'"/>
			
			<Bio1/>
		</v-content>
	</v-app>
</template>

<script>
import Resume from './components/Resume'
import Bio1 from './components/Bio1'

// sudo chown -R $(whoami) ~/.npm
// sudo chown -R $(whoami) /usr/local/lib/node_modules
// sudo chown -R $(whoami) /usr/local/bin
// sudo chown -R $(whoami) /usr/local/share

// npm install -g vue
// npm install -g yarn

// npm install

// npm run serve
// npm run build
// firebase deploy

export default {
	name: 'App',
	components: {
		Resume, Bio1
	},
	data () {
		return {
			page: 'Resume'
		}
	}
}
</script>
